// Module
var code = "<p> <label>Blend</label> <input type=\"range\" min=\"0\" max=\"1\" step=\"0.01\" oninput=\"blend.p.blend.set(event.target.value)\"> </p>";
// Exports
export default code;